import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export default ({ $axios, $config }, inject) => {
  inject('createAiEcho', (token = null) => {
    const scheme = $config.aiWebsocketScheme || 'http'
    const forceTLS = scheme === 'https'
    const baseUrl = String(
      $axios.defaults.baseURL || `${$config.apiBaseUrl || ''}/api`
    ).replace(/\/$/, '')

    return new Echo({
      broadcaster: 'reverb',
      client: new Pusher($config.aiWebsocketKey, {
        wsHost: $config.aiWebsocketHost || window.location.hostname,
        wsPort: Number($config.aiWebsocketPort || 8080),
        wssPort: Number($config.aiWebsocketPort || 8080),
        forceTLS,
        // pusher-js only uses the "ws" transport when forceTLS is set ("wss" is
        // its non-TLS fallback), so ['wss'] alone leaves no usable transport.
        enabledTransports: ['ws', 'wss'],
        enableStats: false,
        // Required by the protocol client; Reverb uses wsHost.
        cluster: '',
        channelAuthorization: {
          endpoint: `${baseUrl}/broadcasting/auth`,
          transport: 'ajax',
          headers: token ? { Authorization: token } : {},
        },
      }),
    })
  })
}
